export default "__VITE_ASSET__41ba446a__"